import React from 'react';
import { CheckCircle2Icon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const rows = [['Arriver à l’entraînement sans plan', 'Tout est prêt en 5 minutes'], ['Chercher des exercices en ligne', 'Curriculum complet sur 365 jours'], ['Lacunes dans la progression', 'Progression logique et mesurable'], ['Évaluation au jugé', 'Guide de tests de performance inclus'], ['Pas de structure annuelle', 'Planificateur de saison inclus'], ['Culture d’équipe fragile', 'Protocole de Discipline & Culture']];
export function FinalCTA() {
  return <section className="border-y-4 border-[#d4af37] bg-[#0A0A0A] px-5 py-20" data-id="element-36">
      <div className="mx-auto max-w-3xl text-center" data-id="element-37">
        <h2 className="font-display text-4xl font-bold uppercase leading-none text-white sm:text-6xl" data-id="element-38">
          Sans RUGBY PRÊT vs{' '}
          <span className="text-[#d4af37]" data-id="element-39">Avec RUGBY PRÊT</span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl font-medium leading-relaxed text-[#B0B0C0]" data-id="element-40">
          Le système le plus complet pour entraîneurs ambitieux. Parce que le
          coaching ne devrait pas vous coûter toutes vos soirées.
        </p>
        <div className="mt-10 overflow-hidden border border-[#d4af37]/30 text-left" data-id="element-41">
          <div className="grid grid-cols-2 bg-[#16161F] text-center text-[10px] font-bold uppercase tracking-widest" data-id="element-42">
            <p className="p-4 text-[#B0B0C0]" data-id="element-43">Sans RUGBY PRÊT</p>
            <p className="border-l border-[#d4af37]/30 p-4 text-[#d4af37]" data-id="element-44">
              Avec RUGBY PRÊT
            </p>
          </div>
          {rows.map(([without, withSystem]) => <div key={without} className="grid grid-cols-2 border-t border-[#d4af37]/20 text-xs sm:text-sm" data-id="element-45">
              <p className="flex gap-2 p-4 font-medium text-[#B0B0C0]" data-id="element-46">
                <span className="text-red-400" data-id="element-47">×</span>
                {without}
              </p>
              <p className="flex gap-2 border-l border-[#d4af37]/20 bg-[#d4af37]/5 p-4 font-semibold text-white" data-id="element-48">
                <CheckCircle2Icon className="h-4 w-4 shrink-0 text-[#d4af37]" data-id="element-49" />
                {withSystem}
              </p>
            </div>)}
        </div>
        <div className="my-9" data-id="element-50">
          <CountdownTimer dark data-id="element-51" />
        </div>
        <div className="border-2 border-[#d4af37] bg-[#16161F] p-7 text-left" data-id="element-52">
          <p className="text-xs font-bold uppercase tracking-widest text-[#d4af37]" data-id="element-53">
            Coffret intégral
          </p>
          <h3 className="mt-2 text-xl font-bold text-white" data-id="element-54">
            RUGBY PRÊT™ — 6 Modules de Coaching + 5 Bonus Stratégiques
          </h3>
          <div className="mt-5 flex items-end justify-between" data-id="element-55">
            <div data-id="element-56">
              <p className="text-sm font-bold text-[#B0B0C0] line-through" data-id="element-57">
                89 €
              </p>
              <p className="font-display text-6xl font-bold leading-none text-white" data-id="element-58">
                19 €
              </p>
            </div>
            <p className="bg-[#d4af37] px-3 py-2 text-xs font-bold uppercase" data-id="element-59">
              Économisez 70 €
            </p>
          </div>
        </div>
        <a href="https://rugby-pret.impultienda.ar/checkout" className="cta-button mt-8 block w-full rounded-2xl px-5 py-5 text-lg font-bold sm:text-xl" data-id="element-60">
          ACCÉDER À RUGBY PRÊT MAINTENANT
        </a>
        <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-[#B0B0C0]" data-id="element-61">
          <span className="flex gap-1" data-id="element-62">
            <LockKeyholeIcon className="h-4 w-4 text-[#d4af37]" data-id="element-63" />
            Paiement sécurisé
          </span>
          <span className="flex gap-1" data-id="element-64">
            <ZapIcon className="h-4 w-4 text-[#d4af37]" data-id="element-65" />
            Accès instantané
          </span>
          <span className="flex gap-1" data-id="element-66">
            <ShieldCheckIcon className="h-4 w-4 text-[#d4af37]" data-id="element-67" />
            Garantie 7 jours
          </span>
        </div>
      </div>
    </section>;
}